import { useFlow } from "@Libs/Flow/hooks/useFlow";
import { CheckoutFlow } from "../Flows/Checkout/Checkout";

export const useCheckout = () => {
  return useFlow(CheckoutFlow);
};
